// extracted by mini-css-extract-plugin
export default {"square":"ColorSquare_square__Esh7C","code":"ColorSquare_code__Z1C0Q"};